if (!customElements.get("redirection-popup")) {
  customElements.define(
    "redirection-popup",
    class RedirectionPopup extends HTMLElement {
      constructor() {
        super();
        this.redirectButtons = this.querySelectorAll(
          ".disclosure__list-wrapper .disclosure__link"
        );
        this.closeButton = this.querySelector(".button-close-js");
        this.modalOverlay = this.querySelector(".modal-overlay-js");
        this.bannerCountry = document.querySelector(
          ".non-shoppable-banner-country"
        );

        this.cookieName = "localePopup";
        this.isCookieSet = false;

        this.userLocale = "";
        this.currStoreCountry = window.Shopify.country;
      }

      connectedCallback() {
        // fires init function
        this.init();
        // add event listener to set cookie on button click
        this.redirectButtons.forEach((button) => {
          button.addEventListener("click", () => {
            this.setCookie(this.cookieName, "showed", 30);
          });
        });
        this.closeButton.addEventListener("click", () => {
          this.setCookie(this.cookieName, "showed", 30);
          this.close();
        });
        this.modalOverlay.addEventListener("click", () => {
          this.setCookie(this.cookieName, "showed", 30);
          this.close();
        });
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && this.classList.contains("show")) {
            this.setCookie(this.cookieName, "showed", 30);
            this.close();
          }
        });
      }

      async init() {
        // checks if the cookie was already set, which is set once users makes a decision on a popup
        if (this.getCookie(this.cookieName) == "showed") return;

        // Fetches user locale
        await this.checkRegion();

        // checks if user locale is present in redirect list array, shows only if it exists as we dont want to show it on every country
        if (!this.shouldShowPopup()) return;

        // opens a popup
        this.open();
      }

      async checkRegion() {
        await fetch(window.shopUrl + "/browsing_context_suggestions.json")
          // await fetch('/browsing_context_suggestions.json') // use for development
          .then((response) => response.json())
          .then((responseJson) => {
            this.userLocale = responseJson?.detected_values?.country?.handle;
          });
      }

      shouldShowPopup() {
        if (this.userLocale == undefined || this.userLocale == "") return false;
        if (this.userLocale == this.currStoreCountry) return false;
        return true;
      }

      open() {
        this.classList.add("show");
      }

      close() {
        this.classList.remove("show");
      }

      setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
      }

      getCookie(cookieName) {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();

          // Check if the cookie starts with the specified name
          if (cookie.startsWith(`${cookieName}=`)) {
            // Get the cookie value by extracting everything after the equals sign
            const value = cookie.substring(cookieName.length + 1);
            return decodeURIComponent(value);
          }
        }

        return false;
      }
    }
  );
}
